import { APIError } from '../APIError';
import { TicketDetail, TicketSummary, TicketType } from '../types/tickets';

type SetDetailErrorAction = {
  readonly type: 'set_ticket_detail_error';
  readonly err: APIError | null;
};

type SetFiltersAction = {
  readonly type: 'set_ticket_filters';
  readonly filters: URLSearchParams;
};

type SetListErrorAction = {
  readonly type: 'set_ticket_list_error';
  readonly err: APIError | null;
};

type SetLoadingAction = {
  readonly type: 'set_tickets_loading';
  readonly loading: boolean;
};

type SetSelectedTicketAction = {
  readonly type: 'set_selected_ticket';
  readonly ticket: TicketType | null;
};

type UpdateListAction = {
  readonly type: 'update_ticket_list';
  readonly tickets: Array<TicketSummary>;
  readonly includeInactive: boolean;
  readonly after: string | null;
  readonly isSystemData: boolean;
};

type UpdateTicketAction = {
  readonly type: 'update_ticket';
  readonly ticket: TicketDetail;
};

export type TicketAction =
  | SetDetailErrorAction
  | SetFiltersAction
  | SetListErrorAction
  | SetLoadingAction
  | SetSelectedTicketAction
  | UpdateListAction
  | UpdateTicketAction;

export const TICKET_ACTIONS = {
  DETAIL_ERROR: (err: APIError | null): SetDetailErrorAction => ({
    type: 'set_ticket_detail_error',
    err,
  }),
  SET_FILTERS: (filters: URLSearchParams): SetFiltersAction => ({
    type: 'set_ticket_filters',
    filters,
  }),
  SET_SELECTED_TICKET: (
    ticket: TicketType | null,
  ): SetSelectedTicketAction => ({
    type: 'set_selected_ticket',
    ticket,
  }),
  LIST_ERROR: (err: APIError | null): SetListErrorAction => ({
    type: 'set_ticket_list_error',
    err,
  }),
  LIST_LOADING: (loading: boolean): SetLoadingAction => ({
    type: 'set_tickets_loading',
    loading,
  }),
  UPDATE_TICKET: (ticket: TicketDetail): UpdateTicketAction => ({
    type: 'update_ticket',
    ticket,
  }),
  UPDATE_LIST: (
    tickets: Array<TicketSummary>,
    includeInactive: boolean,
    after: string | null,
    isSystemData: boolean,
  ): UpdateListAction => ({
    type: 'update_ticket_list',
    tickets: tickets,
    includeInactive,
    after,
    isSystemData,
  }),
};
